import {useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, borderRadius, flexAbsoluteCenter, flexDirection, mb, onDesktop, p, pb, ph} from "@pg-design/helpers-css";
import {Tabs} from "@pg-design/tabs";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";
import {PricesChartChart} from "./prices_chart/PricesChartChart";
import {PricesChartDescription} from "./prices_chart/PricesChartDescription";
import {PricesChartHeader} from "./prices_chart/PricesChartHeader";

export enum RoomsType {
    GENERAL,
    ONE_ROOM,
    TWO_ROOMS,
    THREE_ROOMS,
    FOUR_OR_MORE_ROOMS
}

const tabs = [
    {title: "Ogółem", value: RoomsType.GENERAL},
    {title: "Kawalerki", value: RoomsType.ONE_ROOM},
    {title: "2 pokojowe", value: RoomsType.TWO_ROOMS},
    {title: "3 pokojowe", value: RoomsType.THREE_ROOMS},
    {title: "4+", value: RoomsType.FOUR_OR_MORE_ROOMS}
];

interface IProps {
    type: PricesViewType;
    region: IRegionReportPrice;
}

export const PricesChart = (props: IProps) => {
    const [roomsType, setRoomsType] = useState(RoomsType.GENERAL);

    const yearAgoData = useSelector((state: IRPStore) => state.report.price.yearAgoPrices) as IPriceReportAveragePrices;
    const pricesData = useSelector((state: IRPStore) => state.report.price.prices);

    const actualData = pricesData && pricesData[pricesData.length - 1];
    const monthBeforeData = pricesData && pricesData[pricesData.length - 2];

    const onSetRoomsType = (roomType: RoomsType) => {
        setRoomsType(roomType);

        pricesReportAnalytics.gtm.viewEvent(`${PricesReportGTMViewAction.ROOMS} - ${roomType}`);
    };

    return (
        <Container css={mb(8)}>
            <div css={tabsHolder}>
                <Tabs activeColor="full-dark" onChange={onSetRoomsType} color="gray" tabs={tabs} value={roomsType} variant="line" fullWidth />
            </div>

            <div css={chartWrapper}>
                <PricesChartHeader type={props.type} roomsType={roomsType} actualData={actualData} region={props.region} />

                <PricesChartChart pricesData={pricesData} roomsType={roomsType} />

                <PricesChartDescription
                    type={props.type}
                    rooms={roomsType}
                    actualData={actualData}
                    monthBeforeData={monthBeforeData}
                    yearAgoData={yearAgoData}
                    region={props.region}
                />
            </div>
        </Container>
    );
};

const tabsHolder = css`
    ${mb(2)};
    ${pb(0.5)};
    overflow-x: scroll;

    ${onDesktop(css`
        ${ph(3)};
        overflow-x: unset;
    `)};
`;

const chartWrapper = css`
    ${backgroundColor("#fff")};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${borderRadius(2)};
    ${p(1.5)};

    ${onDesktop(css`
        ${p(3)};
    `)};
`;
import {useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, borderRadius, flexAbsoluteCenter, flexDirection, mb, onDesktop, p, pb, ph} from "@pg-design/helpers-css";
import {Tabs} from "@pg-design/tabs";

import {IRPStore} from "../../../app/rp_reducer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";
import {PricesChartChart} from "./prices_chart/PricesChartChart";
import {PricesChartDescription} from "./prices_chart/PricesChartDescription";
import {PricesChartHeader} from "./prices_chart/PricesChartHeader";

export enum RoomsType {
    GENERAL,
    ONE_ROOM,
    TWO_ROOMS,
    THREE_ROOMS,
    FOUR_OR_MORE_ROOMS
}

const tabs = [
    {title: "Ogółem", value: RoomsType.GENERAL},
    {title: "Kawalerki", value: RoomsType.ONE_ROOM},
    {title: "2 pokojowe", value: RoomsType.TWO_ROOMS},
    {title: "3 pokojowe", value: RoomsType.THREE_ROOMS},
    {title: "4+", value: RoomsType.FOUR_OR_MORE_ROOMS}
];

interface IProps {
    type: PricesViewType;
    region: IRegionReportPrice;
}

export const PricesChart = (props: IProps) => {
    const [roomsType, setRoomsType] = useState(RoomsType.GENERAL);

    const yearAgoData = useSelector((state: IRPStore) => state.report.price.yearAgoPrices) as IPriceReportAveragePrices;
    const pricesData = useSelector((state: IRPStore) => state.report.price.prices);

    const actualData = pricesData && pricesData[pricesData.length - 1];
    const monthBeforeData = pricesData && pricesData[pricesData.length - 2];

    const onSetRoomsType = (roomType: RoomsType) => {
        setRoomsType(roomType);

        pricesReportAnalytics.gtm.viewEvent(`${PricesReportGTMViewAction.ROOMS} - ${roomType}`);
    };

    return (
        <Container css={mb(8)}>
            <div css={tabsHolder}>
                <Tabs activeColor="full-dark" onChange={onSetRoomsType} color="gray" tabs={tabs} value={roomsType} variant="line" fullWidth />
            </div>

            <div css={chartWrapper}>
                <PricesChartHeader type={props.type} roomsType={roomsType} actualData={actualData} region={props.region} />

                <PricesChartChart pricesData={pricesData} roomsType={roomsType} />

                <PricesChartDescription
                    type={props.type}
                    rooms={roomsType}
                    actualData={actualData}
                    monthBeforeData={monthBeforeData}
                    yearAgoData={yearAgoData}
                    region={props.region}
                />
            </div>
        </Container>
    );
};

const tabsHolder = css`
    ${mb(2)};
    ${pb(0.5)};
    overflow-x: scroll;

    ${onDesktop(css`
        ${ph(3)};
        overflow-x: unset;
    `)};
`;

const chartWrapper = css`
    ${backgroundColor("#fff")};
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${borderRadius(2)};
    ${p(1.5)};

    ${onDesktop(css`
        ${p(3)};
    `)};
`;
